module.exports = {
      id: "shareicon-usage",
      viewBox: "0 0 74 74",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#shareicon",
      toString: function () {
        return this.url;
      }
    }